var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slice--subscribe text-24 md-text-44 px-15 py-30 md-px-30",style:({backgroundColor: _vm.slice.primary.bg_color, color: _vm.slice.primary.text_color})},[_c('subscribe-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }